export const HIGHCHARTS_OPTIONS = {
  lang: {
    thousandsSep: ',',
    numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E'],
  },
  title: {
    text: undefined,
  },
  credits: {
    enabled: false,
  },
  legend: {
    enabled: false,
  },
  plotOptions: {
    area: {
      fillColor: 'rgba(196, 159, 214, 0.2)',
      lineWidth: 2.5,
    },
    series: {
      animation: true,
      color: '#603276',
      marker: {
        enabled: false,
      },
      states: {
        hover: {
          enabled: false,
        },
      },
    },
  },
  tooltip: {
    enabled: false,
  },
  xAxis: {
    title: {
      text: undefined,
    },
    minTickInterval: 24 * 3600 * 1000 * 30 * 3,
    tickLength: 0,
    labels: {
      enabled: false,
    },
  },
  yAxis: {
    title: {
      text: undefined,
    },
    labels: {
      enabled: false,
    },
  },
};

export const CHART_OPTIONS: any = {
  chart: {
    type: 'area',
    spacing: [1, 1, 4, 1],
  },
};
